export enum DashboardScreen {
  Dashboard = 'Dashboard',
  Tip = 'Tip',
  Onboarding = 'Onboarding',
  NPOnboarding = 'NPOnboarding',
  StartGuide = 'StartGuide',
  Loyalt = 'Loyalt',
  HubSpotIntegration = 'HubSpot Integration',
  AIFlow = 'AI Flow',
  SellCoinsReactivation = 'Sell Coins Reactivation'
}
